import { render, staticRenderFns } from "./Cohort.vue?vue&type=template&id=45ffdf92&"
import script from "./Cohort.vue?vue&type=script&lang=js&"
export * from "./Cohort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports